import { render, staticRenderFns } from "./FaceEditModal.vue?vue&type=template&id=547fb8ae&scoped=true"
import script from "./FaceEditModal.vue?vue&type=script&lang=ts"
export * from "./FaceEditModal.vue?vue&type=script&lang=ts"
import style0 from "./FaceEditModal.vue?vue&type=style&index=0&id=547fb8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547fb8ae",
  null
  
)

export default component.exports